
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";

class Coins
{
    private conquer                 : CONQUER;
    private gameInstance            : GameInstance;

    private meVar                   : string = "GameCoins";
    private rivalVar                : string = "RivalGameCoins";
    private Reward                  : string = "RewardCoins";
    private permanentMultiplier     : number = 1;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
    }

    public reset() 
    {
        this.set( 0 );
        this.setRival( 0 );
        this.setPermanentMultiplier();
        this.gameInstance.Data.display( this.Reward, 0 )
    }

    /*=======================


    ME


    ========================*/

    public get()
    {
        return this.gameInstance.Data.get( this.meVar );
    };
    
    public set( value:number )
    {
        this.conquer.Avatars.ME.vars.gameCoin = this.gameInstance.Data.display( this.meVar, value );
    };
 
    public setPermanentMultiplier ( value:number=1 )
    {
        this.permanentMultiplier = value || 1;
    };

    public increase( value:number=1 )
    {
        value = value * this.permanentMultiplier;

        this.gameInstance.Signal.set( "GameCoinsIncrease", value );
        this.gameInstance.Signal.set( "CoinEarned", value );
 
        this.set( this.get() + value );
       // this.conquer.Sounds.SFX.play('Coin');
    };

    public toScore( multiplier:number=1 )
    {
        this.gameInstance.Score.increase( this.get() * multiplier );
        this.gameInstance.Score.increaseRival( this.getRival() * multiplier );
    }

    /*=======================


    RIVAL


    ========================*/

    public increaseRival ( value:number )
    {
        this.set( this.getRival() + value );
    };
 
    public setRival( value:number )
    {
        this.gameInstance.Data.display( this.rivalVar, value );
        if( this.gameInstance.Rivals.RIVAL ) this.gameInstance.Rivals.RIVAL.vars.gameCoin = value;
    };
 
    public getRival()
    {
        return this.gameInstance.Data.get( this.rivalVar );
    };
 
};

export default Coins;